export default __webpack_public_path__ + "static/media/twick1.be03bd5d.jpg";